export enum RADIO_FILTER_OPTION {
  YES = '1',
  NO = '0',
  ALL = '2',
}
